import React, { useState } from 'react';
import './SystemFeatures.css';

import { Heading } from '../../../components';
import { systemFeatures } from '../../../constants';



const SystemFeatures = () => {

  const [activeTab, setActiveTab] = useState('residential');

  const activeTabData = systemFeatures.tabs.find(tab => tab.id === activeTab);

  return (
    <section className="tab-info system-features">

      {/* Section Heading */}
      <Heading title={systemFeatures.heading} subTitle={systemFeatures.sub} />

      {/* Tab Buttons */}
      <div className="tab-buttons">
        {systemFeatures.tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <div className="tab-sections">

        {/* Tab Content */}
        <div className={`tab-section ${activeTab === activeTabData.id ? 'active' : ''}`} id={activeTabData.id}>

          <div className="box-container">

            {/* About Image */}
            <div className="image">
              <img src={activeTabData.image} alt={activeTabData.alt} />
            </div>

            {/* Introduction Content */}
            <div className="content">

              {/* Main Heading */}
              <div className="heading">
                <h2>{activeTabData.heading}</h2>
              </div>

              {/* Description */}
              <p>{activeTabData.description}</p>

              {/* Key Features */}
              <div className="key-features">

                {/* Split features into two rows */}
                {[activeTabData.features.slice(0, 4), activeTabData.features.slice(4)].map((featureGroup, index) => (
                  <ul key={index} className="feature-container">
                    {featureGroup.map((feature, i) => (
                      <li key={i}>
                        <div className='icon'>{feature.icon}</div>
                        <span>{feature.title}</span>
                      </li>
                    ))}
                  </ul>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemFeatures;